<template>
  <div class="page">
    <div class="head">
        批次管理
    </div>
    <div class="content">
      <!--   <div class="bar">
            
            
        </div> -->
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                fixed
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column

                    prop="name"
                    width="70"
                    label="批次名">
                </el-table-column>
                <el-table-column
                    prop="startAt"
                    width="100"
                    label="一稿开始时间">
                </el-table-column>
                <el-table-column
                    prop="endAt"
                      width="100"
                    label="一稿截止时间">
                </el-table-column>

             

                <el-table-column
                    prop="specialStartAt"
                      width="100"
                    label="二稿开始时间">
                </el-table-column>
                <el-table-column
                    prop="specialEndAt"
                      width="100"
                    label="二稿截止时间">
                </el-table-column>

            
                <el-table-column
                    prop="synScoreAt"
                      width="100"
                    label="成绩同步时间">
                </el-table-column>
                <el-table-column
                    prop="synStatusAt"
                      width="100"
                    label="状态同步时间">
                </el-table-column>


                <el-table-column
                    prop="publishAt"
                      width="100"
                    label="发布时间">
                </el-table-column>
                <el-table-column label="操作"  fixed="right">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="editHandler(record.row)" type="primary">编辑</el-link>
                        <el-link :underline="false" @click.prevent="editHandler2(record.row)" type="primary">审批人</el-link>
                        <el-link :underline="false" :disabled="!record.row.canSyn" @click.prevent="editHandler3(record.row)" type="primary">同步状态</el-link>
                        <el-link :underline="false" :disabled="!record.row.canSyn" @click.prevent="editHandler4(record.row)" type="primary">同步成绩</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />

        <el-dialog
          title=""
          :visible.sync="dialogVisible3"
          width="30%"
          :before-close="handleClose">
          <span>您确定要同步状态吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible3 = false">取 消</el-button>
            <el-button type="primary" @click="synStatus">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title=""
          :visible.sync="dialogVisible4"
          width="30%"
          :before-close="handleClose">
          <span>您确定要同步成绩吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible4 = false">取 消</el-button>
            <el-button type="primary" @click="synScore">确 定</el-button>
          </span>
        </el-dialog>



         <el-dialog title="选择审批人" :visible.sync="showAudit">
            <el-form ref="userForm1" :model="form1" >
                <el-form-item  label="批次名称" label-width="100px" prop="name">
                        <span class="bartip">{{form1.name}}</span>
                </el-form-item>
                <el-form-item  label="审批人" label-width="100px" prop="name">
                    <el-checkbox-group v-model="selectedUsers"  >
                        <el-checkbox :label="item.id" v-for="item,index in users" :key="index" class="ques">{{item.displayName}}</el-checkbox>
                    </el-checkbox-group>
                
                </el-form-item>
                <el-form-item  label="" label-width="100px" prop="">
                <span class='chosen'>已选择 {{selectedUsers.length}} 人</span>
                 </el-form-item>



            </el-form>

               <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal1">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler1">确 定</el-button>
            </div>

         </el-dialog>
        
        <!-- 表单 修改批次 -->
        <el-dialog :title="title2" :visible.sync="visible2" @close="dialogCloseHandler2">
            <el-form ref="userForm2" :model="form2" >
                <el-form-item  label="批次名称" label-width="130px" prop="name">
                <el-input :disabled="true" v-model="form2.name" autocomplete="off" />
                </el-form-item>
                <el-form-item  label="一稿开始时间" label-width="130px" prop="startAt">
                 <el-date-picker
                    v-model="form2.startAt"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-ddTHH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <el-form-item  label="一稿截止时间" label-width="130px" prop="updatedAt">
                <el-date-picker
                    v-model="form2.endAt"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-ddTHH:mm:ss">
                  </el-date-picker>
                </el-form-item>

             

                 <el-form-item  label="二稿开始时间" label-width="130px" >
                  <el-date-picker
                    v-model="form2.specialStartAt"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-ddTHH:mm:ss">
                  </el-date-picker>
                </el-form-item>


                 <el-form-item  label="二稿截止时间" label-width="130px" >
                  <el-date-picker
                    v-model="form2.specialEndAt"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-ddTHH:mm:ss">
                  </el-date-picker>
                </el-form-item>

                 <el-form-item  label="发布时间" label-width="130px" >
                  <el-date-picker
                    v-model="form2.publishAt"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-ddTHH:mm:ss">
                  </el-date-picker>
                </el-form-item>


                 

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal2">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler2">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],
        query: {
        currentPage: 1,
        size: 10,
        page:0,
        total: 0,
        keyword:'',
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加批次信息',
        title2:'修改批次信息',
        form1: {},
        form2:{},
        showAudit:false,

        users:[],
        selectedUsers:[],
        dialogVisible3:false,
        dialogVisible4:false,
        rowId:0,
    }
 },
 methods:{
     findBatchlist(){
        ajaxObj({url: "users/batches",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            console.log(this.tableData);
            this.query.total = response.data.meta.total;
        })
     },
      // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;
    },
    
    
    // addUser(){
    //     ajaxObj({url: "users/add-teacher",method: "post",
    //      data:{
    //         "code":code,
    //         "name":name,
    //         "password":password,
    //         "displayName":displayName,
    //         "roleId":roleId,
    //      }
    //     })
    //     .then(response => {
    //         this.$message({ type: 'success', message: '添加成功'})
    //     })
    // },

    // 修改批次  表单
    dialogCloseHandler2() {
        this.$refs.userForm2.clearValidate()
    },
    setTitle2(title2) {
        this.title2 = title2
    },
    closeModal1(){
        this.showAudit=false;

    },
    closeModal2() {
      this.visible2 = false
    },
    showModal2() {
      this.visible2 = true
    },

    submitHandler1(){
         const loading = this.$loading({
          lock: true,
          text: '正在保存，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        ajaxObj({url: "batches/users",method: "post",
                data:{
                    id:this.form1.id,
                    users:this.selectedUsers
                }
            })
            .then((response) => {
                if(response.data.data == -1){
                    this.$message({ type: 'error', message: '审批已经开始，不能修改审批人' });
                }else{
                    this.$message({ type: 'success', message: '修改成功' });
                       this.showAudit =false;
                }
                loading.close()

                                          
            })

    },

    submitHandler2(){
            // 表单验证
        this.$refs.userForm2.validate((valid) => {
            if (valid) {
            // 2 提交表单
                ajaxObj({url: "users/batches/update",method: "post",
                    data:this.form2
                })
                .then((response) => {
                    this.$message({ type: 'success', message: '修改成功' });
                    this.reload()                                               
                })
            } else {
                this.$message({ type: 'error', message: '修改失败' })
            }
        })
    },
    //  删除批次
     
    //  修改批次
     editHandler(row){
          this.form2 = row
        this.setTitle2('修改批次信息')
        this.showModal2()
      
     },

     editHandler2(row){
        this.form1 = row;
        this.showAudit = true;
          ajaxObj({url: "batches/users",method: "get",params:{id:row.id}})
            .then(response => {
                this.selectedUsers = response.data.data;
            })

     },

    editHandler3(row){
        this.rowId = row.id;
        this.dialogVisible3=true;
    },

    editHandler4(row){
        this.rowId = row.id;
        this.dialogVisible4 =true;
    },


    synScore(){
        // this.form1 = row;
        // this.showAudit = true;
      ajaxObj({url: "batches/syn-score",method: "post",data:{id:this.rowId}})
        .then(response => {
             this.$message({ type: 'success', message: '本次同步用户数为'+response.data.data });
            //this.selectedUsers = response.data.data;

              ajaxObj({url: "users/batches",method: "get",params:this.query})
                .then(response => {
                    this.tableData = response.data.data;
                    this.query.total = response.data.meta.total;
                })

        })
        this.dialogVisible4 =false;


    },

    synStatus(){
        // this.form1 = row;
        // this.showAudit = true;
        ajaxObj({url: "batches/syn-status",method: "post",data:{id:this.rowId}})
            .then(response => {
                this.$message({ type: 'success', message: '本次同步用户数为'+response.data.data });
               ajaxObj({url: "users/batches",method: "get",params:this.query})
                .then(response => {
                    this.tableData = response.data.data;
                    this.query.total = response.data.meta.total;
                })
            })

            this.dialogVisible3 =false;
     },
     
     
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
    console.log(this.currentPage) // 点击第几页
        ajaxObj({url: "users/batches",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findBatchlist()
    ajaxObj({url: "users/audit-user",method: "get"})
    .then(response => {
        this.users = response.data.data;
    })

  

    // this.findUserlist();
    // this.findRoleNames();
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}

.el-checkbox{
    text-align: left;
    width: 100px;
}
.chosen{
    font-weight: 600;
 color: #409EFF;

}

</style>



// WEBPACK FOOTER //
// src/views/teach/batch.vue